export default __webpack_public_path__ + "static/media/image-frame-1.567128f0.jpg";